<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  async fetchZipCode(zipCode) {
    const response = await axios.get(`utils/fetch_zip_code/${zipCode}`, AS.getDefaultHeaders())
    return response.data;
  },
};
</script>
